export default {
    props: {
        group: { type: String, default: 'news-listing' }
    }
}